<template>
    <div>
        <div class="modal-header">
            <slot name="modalHeader"></slot>
            <h4 class="modal-title">{{ 'app.products_list' | trans}}</h4>
        </div>
        <div class="modal-body">
            <div v-if="loading">
                <i class="fa fa-refresh fa-spin"></i> Trwa ładowanie...
            </div>
            <div v-if="!loading && productsReplaced">
              <i class="fa fa-refresh fa-spin"></i> Trwa zapisywanie jadłospisu...
            </div>
            <div class="callout callout-success" v-else-if="shoppingList && shoppingList.length  === 0">
                Lista zakupów jest pusta.
            </div>
            <table v-if="!productsReplaced && !loading" v-for="category in list" class="table table-bordered table-condensed">
                <thead>
                <tr>
                    <th colspan="4">
                        <h5 class="text-bold">{{category.name}}</h5>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="product in category.products">
                    <td style="width: 40%">{{product.name}}</td>
                    <td style="width: 25%">{{product.totalWeight.amount | round}} {{product.totalWeight.unit}}</td>
                    <td v-bind:style="{'width': (hasPermission('creator_products_replace') || hasPermission('creator_products_search')) ? '25%': '35%'}">
                        <div v-if="product.distinctPortions.length === 1 && product.distinctPortions[0].unit === 'gram'">
                            ---
                        </div>
                        <div v-else>
                            <span v-for="(portion, index) in product.distinctPortions">
                                {{portion.amount | round}} x {{portion.weight.unit}}<span
                                    v-if="index+1 < product.distinctPortions.length">, </span>
                            </span>
                        </div>
                    </td>
                    <td style="width: 10%; text-align: center" v-if="hasPermission('creator_products_replace') || hasPermission('creator_products_search')">
                      <v-icon
                          v-if="hasPermission('creator_products_replace')"
                          v-tooltip="`Zamień produkt`"
                          color="primary" @click="replaceProduct(product)">autorenew</v-icon>
                      <v-icon
                          v-if="hasPermission('creator_products_search')"
                          v-tooltip="trans('app.search_products')"
                          color="cyan darken-1"
                          @click="searchProducts(product)"
                      >search</v-icon>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-footer">
            <v-btn color="primary" small flat @click="hideModal()">
                {{ 'app.close' | trans }}
            </v-btn>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapMutations, mapState } from 'vuex';

  export default {
    data() {
      return {
        shoppingList: null,
        loading: false,
      };
    },

    created() {
      this.loadList();
      this.$root.$on('menuSaved', this.loadList);
    },

    destroyed() {
      this.shoppingList = null;
      this.$root.$off('menuSaved');
    },
    computed: {
      ...mapState(['menu']),
      ...mapGetters([
        'configuration',
        'productsReplaced',
        'hasPermission',
      ]),
      list() {
        return this.shoppingList;
      },
    },
    methods: {
      ...mapMutations([
        'hideModal',
        'showModal'
      ]),

      loadList() {
        this.loading = true;
        axios.get(this.configuration.shoppingList).then((response) => {
          this.shoppingList = response.data.data.categories;
          this.loading = false;
        }).catch((error) => {
          this.sentryCaptureException(error);
        });
      },
      replaceProduct(product) {
        this.showModal({
          component: 'replace-search-product-modal',
          data: {
            productToReplace: product,
          },
        });
      },
      searchProducts(product) {
        this.$root.$emit('search-product-selected', product);
        this.hideModal();
      }
    },
  };
</script>
